import Box from 'assets/components/box/Box';
import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import DataMap from 'assets/components/dataMap/DataMap';
import Icon from 'assets/components/icon/Icon';
import Page from 'assets/components/page/Page';
import ThemePageError from 'assets/components/page/themes/Theme.Page.Error';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import { getLocales } from 'assets/locales/Locale';
import ThemeWrapperStack from 'assets/themes/wrappers/Theme.Wrapper.Stack';
import { LossCodeAction, useLossCodeProvider } from '../LossCode.Hooks';

export default function LossCodeList() {
  const { lang } = getLocales();
  const { listApi, pageRouter, permissions } = useLossCodeProvider();

  return !listApi.payload && !listApi.isExecuting && listApi.apiCounter > 0 ? (
    <Page
      class={ThemePageError}
      sidebar={<Icon class="fas-clipboard-list" />}
      header={lang.lossCodes}
      render={lang.noInfo}
    />
  ) : (
    <table className={ThemeTableSimple} data-loading={listApi.isExecuting ? true : undefined}>
      <thead>
        <tr>
          <th>{lang.descnEn}</th>
          <th>{lang.code}</th>
          <th>{lang.category}</th>
          <th>{lang.notes}</th>
          <th data-actions>{lang.actions}</th>
        </tr>
      </thead>
      <tbody>
        <DataMap
          data={listApi.payload?.data}
          render={({ data: lossCode }) => (
            <tr key={lossCode.id}>
              <td>
                <b>{lossCode.descnEn ?? 'N/A'}</b>
              </td>
              <td>{lossCode.code}</td>
              <td>{lossCode.category}</td>
              <td>{lossCode.notes}</td>
              <td>
                <Box class={ThemeWrapperStack}>
                  <Button
                    onClick={pageRouter.updateParams}
                    data={{
                      id: lossCode.id.toString(),
                      action: LossCodeAction.EDIT,
                    }}
                    disabled={!permissions.EDIT_LOSSCODE}
                    active
                    class={ThemeButtonCircle}
                    htmlElementProps={{
                      title: lang.edit,
                    }}
                    media={<Icon class="fas-edit" />}
                  />
                  <Button
                    onClick={pageRouter.updateParams}
                    data={{
                      id: lossCode.id.toString(),
                      action: LossCodeAction.DELETE,
                    }}
                    disabled={!permissions.DELETE_LOSSCODE}
                    active
                    class={ThemeButtonCircle}
                    htmlElementProps={{
                      title: lang.delete,
                    }}
                    media={<Icon class="fas-trash" />}
                  />
                </Box>
              </td>
            </tr>
          )}
        />
      </tbody>
    </table>
  );
}
